import { Grid } from "@mui/material";
import React from "react";
import LeaveHeader from "./home/header";
import LeaveTabel from "./home/table";

const Leave = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <LeaveHeader />
      </Grid>
      <Grid item xs={12}>
        <LeaveTabel />
      </Grid>
    </Grid>
  );
};

export default Leave;
